import { TransitSafeLogo } from './TransitSafeLogo';

interface BrandStripProps {
  /** Right-aligned context label (e.g. "FAA Part 145") — optional. */
  context?: string;
}

/**
 * Slim brand strip rendered above the PageShell title — shows the
 * TransitSafe mark + wordmark on every aviation-demo page so the umbrella
 * brand is visible independent of the page-specific title.
 *
 * TransitSafe is multi-tenant (transitsafe = aviation, and future maritime
 * / auto / rail variants), so this strip shows ONLY the umbrella wordmark
 * — per-mode context ("AVIATION", "MARITIME") lives in the PageShell
 * `title` or the optional `context` prop here.
 */
export function BrandStrip({ context }: BrandStripProps) {
  return (
    <div className="flex items-center justify-between gap-3 py-2">
      <div
        className="flex items-center gap-2"
        data-testid="aviation-demo-brand-strip"
      >
        <TransitSafeLogo size={22} />
        <span className="text-sm font-bold tracking-wider text-gray-900 dark:text-slate-100">
          TRANSITSAFE
        </span>
      </div>
      {context && (
        <span className="text-[10px] font-bold uppercase tracking-wider text-gray-500 dark:text-slate-400">
          {context}
        </span>
      )}
    </div>
  );
}
